class WishlistTrigger extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)

    this.addToWishlist = this.addToWishlist.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      if (!this.isLoggedIn()) {
        this.setInactiveState()
        return
      }

      this.checkIsInWishlist()

      this.els.trigger?.elements.forEach((el) => {
        el.setAttribute('data-wishlist-active', '')
      })
    })
  }

  isLoggedIn () {
    return this.hasAttribute('data-is-customer')
  }

  setInactiveState () {
    this.els.trigger?.elements.forEach((el) => {
      el.setAttribute('data-wishlist-inactive', '')
      el.removeAttribute('data-wishlist-active')
      el.removeAttribute('data-wishlist-added')
      el.removeAttribute('data-wishlist-id')
    })
  }

  showLoginAlert () {
    const alert = this.externalEls.alert.element

    alert.removeAttribute('hidden')
    alert?.querySelector('[data-alert-content]')?.focus()

    setTimeout(() => {
      alert.setAttribute('hidden', '')
    }, 4000)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-trigger-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    if (!this.isLoggedIn()) {
      this.showLoginAlert()
      return
    }

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: trigger.dataset.productUrl,
      }

      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      this.addToWishlist('My wishlist')
    }
  }

  addToWishlist (desiredListName) {
    window._swat.fetchLists({
      callbackFn: (lists) => {
        const targetList = lists.find(
          (list) => list.listname === desiredListName,
        )

        if (!targetList) {
          window._swat.createList(
            { lname: desiredListName },
            (newList) => this.addProductToList(newList.lid),
            this.wishlistError,
          )
        } else {
          this.addProductToList(targetList.lid)
        }
      },
      errorFn: this.wishlistError,
    })
  }

  addProductToList (lid) {
    const product = {
      epi: parseInt(this.els.trigger.element.dataset.variantId),
      empi: parseInt(this.els.trigger.element.dataset.productId),
      du: this.els.trigger.element.dataset.productUrl,
    }

    window._swat.addToList(
      lid,
      product,
      this.handleSuccess,
      this.wishlistError,
    )
  }

  handleSuccess () {
    this.checkIsInWishlist()
  }

  checkIsInWishlist () {
    if (!this.isLoggedIn()) return

    window._swat.fetchLists({
      callbackFn: (lists) => {
        this.els.trigger?.elements.forEach((el) => {
          const matchedProduct = lists.find((list) =>
            list.listcontents.find(
              (product) => product.epi === parseInt(el.dataset.variantId),
            ),
          )

          if (matchedProduct) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedProduct.lid)
            el.textContent = window.theme.wishlist.removeItem
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
            el.textContent = window.theme.wishlist.addItem
          }

          el.setAttribute('data-wishlist-active', '')
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line no-console
    console.log(`Wishlist error: ${errorMessage}`)
  }
}

if (!customElements.get('wishlist-trigger')) {
  customElements.define('wishlist-trigger', WishlistTrigger)
}
